import {Environment} from '@react-three/drei'
import PerformanceMonitor from '../../../../../packages/shared/components/PerformanceMonitor'
import {Fog} from '../Fog/Fog'
import {GameCamera} from '../GameCamera/GameCamera'
import World from '../World/World'

const Game = () => (
  <>
    <PerformanceMonitor />
    <GameCamera />
    <World />
    <Environment files="hdr/snowy_park_01_2k.hdr" />
    <Fog />
  </>
)

export default Game
